import { useCallback, useState } from 'react';

import { CreateChatDefaultModalData } from '../../data/data/types';

const useScheduleAppointmentModal = () => {
  const [scheduleAppointmentModalData, setScheduleAppointmentModalData] =
    useState<CreateChatDefaultModalData | null>(null);
  const showScheduleAppointmentModal = useCallback(
    (value: CreateChatDefaultModalData | null) => {
      setScheduleAppointmentModalData(
        value
          ? {
              onClose: () => {
                setScheduleAppointmentModalData(null);
              },
              ...value,
            }
          : null
      );
    },
    []
  );
  return { scheduleAppointmentModalData, showScheduleAppointmentModal };
};
export { useScheduleAppointmentModal };
